<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-修改活动
  -->
  <div class="pb50" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      <!--基础设置-->
      <Basic :form="form"></Basic>
      <!--活动商品-->
      <Product :form="form" :type="'edit'"></Product>
      <!--其它-->
      <Other :form="form"></Other>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import MultigroupApi from '@/api/multigroup.js';
import Basic from './part/Basic.vue';
import Product from './part/Product.vue';
import Other from './part/Other.vue';
import {mergeTable} from '@/utils/table.js'
export default {
  components: {
    /*基础设置*/
    Basic,
    /*活动商品*/
    Product,
    /*其它*/
    Other
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*表单对象*/
      form: {
        /*活动ID*/
        multigroup_activity_id:null,
        /*图片ID*/
        image_id: 0,
        /*活动日期*/
        active_date: '',
        /*活动时间*/
        active_time: '',
        /*标题*/
        title: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        /*默认排序*/
        sort: 100,
        /*商品源数据*/
        tableData:[],
        /*商品列表*/
        product_list:[]
      }
    };
  },
  created() {
    /*获取列表*/
    this.form.multigroup_activity_id = this.$route.query.multigroup_activity_id;
    this.getData();
  },
  methods: {



    /*获取数据*/
    getData(){
      let self = this;
      self.loading = true;
      MultigroupApi.getActive({multigroup_activity_id:self.form.multigroup_activity_id}, true)
        .then(res => {

          let tempForm=res.data.detail;
          tempForm.multigroup_activity_id=self.form.multigroup_activity_id;
          tempForm.product_del_ids=[];
          tempForm.tableData=[];
          let arr = [];

          for (let i = 0; i < res.data.product_list.length; i++) {
            let item = res.data.product_list[i];
            let obj = {
                product_name: item.product.product_name,
                product_id: item.product.product_id,
                multigroup_activity_id: item.multigroup_activity_id,
                multigroup_product_id: item.multigroup_product_id,
                product_price: item.product.product_price,
                is_delete:item.is_delete,
                sort:item.sort,
              };
              arr.push(obj);
          }
          tempForm.product_list=mergeTable(arr);
          console.log(tempForm)
          self.form=tempForm;
          self.loading = false;

        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;

      // self.form.product_list=self.tableFormet(self.form.tableData);
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          let params = self.form;

          MultigroupApi.saveActive(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.cancelFunc();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*表格数据格式化*/
    tableFormet(list){
      let spec_list=[];
      let newList=[];
      let curItem=null;
      for(let i=0;i<list.length;i++){
        let item=list[i];
        let obj={
          product_sku_id:item.product_sku_id,
          multigroup_stock:item.multigroup_stock,
          multigroup_price:item.multigroup_price,
          product_attr:item.spec_name,
          multigroup_product_sku_id:item.multigroup_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        }
        if(curItem==null){
          curItem=item;
        }
        if(curItem.product_id!=item.product_id){
          curItem.spec_list=spec_list;
          newList.push(curItem);
          curItem=item;
          spec_list=[];
        }
        spec_list.push(obj);
      }
      curItem.spec_list=spec_list;
      newList.push(curItem);
      return newList;
    },


    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/multigroup/active/edit.vue